<div class="button" (click)="showHide()">
    <span *ngIf="!show" class="fa-solid fa-message-question"></span>
    <span *ngIf="show" class="fa-solid fa-xmark"></span>
</div>

<div *ngIf="show" class="window" [@fadeInUpOnEnter] [@fadeOutDownOnLeave]>
    <ng-content></ng-content>
</div>
